<template>
    <div class="MenuTree">
      <label v-for="menu in menuData" :key="menu.r_mn_id">
        <el-submenu :index="menu.r_mn_id" :key="menu.r_mn_id" v-if="menu.children">
          <template slot="title">
            <i :class="menu.r_icon_class"></i>
            <span>{{menu.r_mn_desc}}</span>
          </template>
          <label>
            <menu-tree :menuData="menu.children"></menu-tree>
          </label>
        </el-submenu>
        <el-menu-item v-else :index="menu.r_mn_id" :key="menu.r_mn_id">
          <i :class="menu.r_icon_class"></i>
          <span slot="title">{{menu.r_mn_desc}}</span>
        </el-menu-item>
      </label>
    </div>

</template>

<script>
import MenuTree from '../base/MenuTree.vue'

export default {
  name: 'MenuTree',
  props: ['menuData'],
  date () {
    return {

    }
  },
  components: {
    MenuTree
  }
}
</script>

<style lang="less" scoped>

</style>
